import { render, staticRenderFns } from "./CarsListItem.vue?vue&type=template&id=7c0bdc3b"
import script from "./CarsListItem.vue?vue&type=script&lang=js"
export * from "./CarsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Dropdown: require('/home/forge/farescraper.com/components/Dropdown.vue').default})
